import React from "react";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { camelizeKeys } from "humps";
import { compose } from "ramda";
import SetupTwoFAForm from "./SetupTwoFAForm";
import { sendOTPForm, get2FASettings, get2FACountryCodes } from "../../actions/loginActions";
import AuthLayout from "../common/AuthLayout";

const SetupTwoFAPage = props => {
  return (
    <AuthLayout {...props}>
      <SetupTwoFAForm pageName="2-Factor Authentication" onSubmit={props.sendOTPForm} {...props} />
    </AuthLayout>
  );
};

SetupTwoFAPage.propTypes = {
  sendOTPForm: PropTypes.func.isRequired,
};

const mapStateToProps = (
  {
    app: { client, clientName },
    common: { logoUrl, clientSettings },
    login: { otp, twoFACountryCodes, twoFASettings, twoFAEmailTokenError },
  },
  { query }
) => {
  const camelizeQuery = camelizeKeys(query);

  const defaultCountryCodeItem = twoFACountryCodes.length > 0 ? twoFACountryCodes[0] : {};
  let defaultCountryCode = "";
  for (const key in defaultCountryCodeItem) {
    if (defaultCountryCodeItem.hasOwnProperty(key)) {
      defaultCountryCode = defaultCountryCodeItem[key];
      break;
    }
  }
  return {
    client,
    logoUrl,
    clientName,
    twoFASettings,
    twoFACountryCodes,
    otp,
    validationError: twoFAEmailTokenError,
    twoFaModes: clientSettings.twoFaModes,
    initialValues: {
      clientId: camelizeQuery.clientID,
      requestToken: camelizeQuery.token,
      countryCode: twoFASettings.countryCode || defaultCountryCode,
      mobileNo: twoFASettings.mobileNo,
    },
  };
};

const mapDispatchToProps = {
  sendOTPForm,
  get2FACountryCodes,
  get2FASettings,
};

export default compose(injectIntl, connect(mapStateToProps, mapDispatchToProps))(SetupTwoFAPage);



// WEBPACK FOOTER //
// ./components/twoFA/SetupTwoFAPage.js